import React from 'react';
import { Heading } from '../../../components';
import { treesampleTasks, manifestTree, images } from '../../../constants';
import { FaLeaf, FaFeatherAlt } from 'react-icons/fa';
import './TreeTasks.css';

const TreeTasks = () => {
    return (
        <div className='tree-tasks-container'>

            {/* =========================================
                CZĘŚĆ 1: DZIAŁANIE (Lista / Notatnik)
               ========================================= */}
            <section className='actions-section-bg'>
                <div className='tasks-wrapper'>
                    <Heading title={'Napisz do Drzewa'} subTitle={'Twoja kolej'} />
                    
                    <p className='tasks-intro'>
                        Stare drzewo przy Dworze w Imielnie czeka na Twoje słowa. Zobacz, jak możesz dołączyć do tworzenia żywej historii.
                    </p>

                    {/* ZMIANA: Zamiast Gridu (Kafelków) jest Lista */}
                    <div className='actions-list'>
                        {treesampleTasks.map((task, index) => (
                            <div className='action-row' key={`task-${index}`}>
                                <div className='task-icon-wrapper'>
                                    <FaLeaf className='task-icon' />
                                </div>
                                <span className='task-text'>{task}</span>
                            </div>
                        ))}
                    </div>

                    <p className='tasks-outro'>
                        Każdy list to nowa historia.
                    </p>
                </div>
            </section>

            {/* =========================================
                CZĘŚĆ 2: MANIFEST (Ciemne tło, zdjęcie)
               ========================================= */}
            <section className='manifest-section-bg'>
                <div className='manifest-container'>
                    {/* LEWA KOLUMNA - ZDJĘCIE */}
                    <div className='manifest-image-wrapper'>
                        <img src={images.tree3} alt="Stare drzewo" className="manifest-img" />
                    </div>

                    {/* PRAWA KOLUMNA - TEKST */}
                    <div className='manifest-content-wrapper'>
                        <Heading title={'Nasz Manifest'} subTitle={'W co wierzymy?'} light={true} sideHeading={true} />
                        
                        <p className='manifest-intro-text'>
                            Fundamentem naszej akcji jest uważność i pamięć. Oto wartości, które nam przyświecają, spisane jako nasze zobowiązanie wobec historii i natury.
                        </p>

                        <ul className='manifest-list'>
                            {manifestTree.map((item, index) => (
                                <li key={`manifest-list-${index}`}>
                                    <FaFeatherAlt className="manifest-list-icon" />
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </section>

        </div>
    );
};

export default TreeTasks;